// AuthContext.tsx
import React, { useState, useEffect } from 'react';
import {  useSearchParams } from "react-router";
import { RoleLevel, type AuthUser, type rolesList } from '../../types/Users';
import { Login, Logout, isLoggedIn } from '../../services/Login';
import AuthContext from './AuthContext';
import { redirect } from 'react-router';
import store from '../../stores/store';



const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState<rolesList>();
  const [user,setUser] = useState<AuthUser | null>(null)
  const [searchParams] = useSearchParams();

  useEffect(() => {

    const checkAuth = async function () {
      try {
        const usr= await isLoggedIn(searchParams.get('lost_token'));
        setUser(usr);
        setIsAuthenticated((usr)?true:false);        
        if(usr){
          setUserRole(usr.rangacces);
        }else{
          setUserRole(undefined);
        }
      } catch {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    }

    void checkAuth();
  }, [searchParams]);

  const login = async (username:string,passwd:string) => {
    setIsLoading(true);
    const usr= await Login(username,passwd);
    setUser(usr);
    setIsLoading(false);
    setIsAuthenticated((usr)?true:false);
    if(usr){
      setUserRole(usr.rangacces);
    }else{
      setUserRole(undefined);
    }
    
    return usr;
  };

  const logout =  () => {
    setIsLoading(true);
    void Logout().then((islogedOut)=>{
      setIsLoading(false);
      if(islogedOut) {
        setIsAuthenticated(false);
        setUserRole(undefined);
        setUser(null);

        window.location.reload()
        store.dispatch({type:'login/logout'});
        redirect("/login");
      }
    });
  };
  const hasRole = (role:rolesList) : boolean => {
    if(!isAuthenticated || !userRole) return false;
    return RoleLevel[role] <= RoleLevel[userRole];
  };
  const isRole = (role:rolesList) : boolean => {
    if(!isAuthenticated || !userRole) return false;
    return RoleLevel[role] == RoleLevel[userRole];
  };
  return (
    <AuthContext value={{ isAuthenticated, hasRole,isRole, isLoading, user , userRole, login, logout }}>
      {children}
    </AuthContext>
  );
};

export default AuthProvider;